import React from "react";
import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";

import ProcesosApi from "api/procesosApi";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";

const BarChartProcesosEstado = () => {
  const [datosProcesosEstado, setDatosProcesosEstado] = useState({ labels: [], values: [] });

  useEffect(() => {
    const fetchDatosProcesosEstado = async () => {
      try {
        const respProcesosEstado = await ProcesosApi.obtenerEstadisticas("PROCESOS_POR_ESTADO");
        const data = respProcesosEstado.data;
        const labels = data.map((item) => item.estado);
        const values = data.map((item) => item.cantidad);
        setDatosProcesosEstado({ labels, values });
      } catch (error) {
        console.error("Error al obtener los datos del backend:", error);
      }
    };
    fetchDatosProcesosEstado();
  }, []);

  const colors = [
    "#FFB6C1",
    "#87CEFA",
    "#FFD700",
    "#32CD32",
    "#FFA07A",
    "#9370DB",
    "#40E0D0",
    "#FF6347",
    "#4682B4",
    "#A52A2A",
  ];

  const chartRef = useRef();
  const onClick = (event) => {
    console.log(chartRef.current);
    console.log(event);
  };

  const chartData = {
    labels: datosProcesosEstado.labels,
    datasets: [
      {
        data: datosProcesosEstado.values,
        backgroundColor: colors.slice(0, datosProcesosEstado.labels.length), // Usar colores según la cantidad de estados
        borderColor: colors
          .slice(0, datosProcesosEstado.labels.length)
          .map((color) => `${color}99`), // Color de borde más claro
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: true, // Activa el título
        text: "Procesos por Estado", // Título del gráfico
        font: {
          size: 20, // Tamaño de la fuente del título
          weight: "bold", // Negrita
        },
        color: "#FFFFFF", // Color del texto del título
      },
      tooltip: {
        enabled: true,
        callbacks: {
          // Personaliza el contenido del tooltip
          title: () => "", // Desactiva el título del tooltip
          label: function (context) {
            const label = context.label || ""; // Estado
            const value = context.raw || 0; // Número de procesos
            const procesoText = value === 1 ? "proceso" : "procesos";
            return `${label}: ${value} ${procesoText}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 0,
          color: "#FFFFFF", // Color del texto en el eje X
          font: {
            size: 12,
          },
        },
        grid: {
          color: "rgba(255, 255, 255, 0.1)", // Líneas de la cuadrícula en un color tenue
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          color: "#FFFFFF", // Color del texto en el eje Y
          font: {
            size: 10,
          },
        },
        grid: {
          color: "rgba(255, 255, 255, 0.1)", // Líneas de la cuadrícula en un color tenue
        },
        max: (context) => {
          const maxValue = Math.max(...context.chart.data.datasets[0].data); // Encuentra el valor máximo
          return maxValue + Math.ceil(maxValue * 0.1); // Agrega un 10% de margen
        },
      },
    },
  };

  return (
    <SuiBox
      backgroundColor="dark"
      borderRadius="lg"
      py={2}
      pr={0.5}
      mb={3}
      height="15rem"
      backgroundGradient
    >
      <Bar ref={chartRef} data={chartData} options={options} onClick={onClick} />
    </SuiBox>
  );
};

BarChartProcesosEstado.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    values: PropTypes.arrayOf(PropTypes.number).isRequired,
  }).isRequired,
};

export default BarChartProcesosEstado;
